import type { CollectibleId } from "@/services/collectibles/collectiblesTypes";

export const ParameterSlug_MarketplacePrice = "marketplace-price";

// The API has no dedicated flag to mark category parameters — we identify them by slug.
// This is the only way the API currently provides.
export const ParameterSlug_Category = "category";

// Shared across marketplace/collection/collectibles search composables — these are not
// real elastic filter parameters, so they are kept in the query string, not the filter path.
export const QUERY_FILTER_SLUG = "query";
export const SORT_FILTER_SLUG = "sort";

// Marketplace-only preset filter (see useUrlFilter's extraQueryStringKeys) — also a query-string
// key, comma-separated to match the API's accepted form.
export const COLLECTIBLE_IDS_FILTER_SLUG = "collectibleIds";

/** Comma-separated URL form of a collectible-ids prefilter (deduped); undefined for an empty set so the query param is omitted entirely. */
export const serializeCollectibleIdsParam = (ids: CollectibleId[]): string | undefined => {
  const deduped = [...new Set(ids)];
  return deduped.length > 0 ? deduped.join(",") : undefined;
};

/** Collectible ids from the URL param (string, or array when the param is repeated); non-numeric junk is dropped, ids deduped. */
export const parseCollectibleIdsParam = (value: string | (string | null)[] | null | undefined): CollectibleId[] => {
  const raw = Array.isArray(value) ? value.filter((part): part is string => part !== null) : value ? [value] : [];
  const ids = raw
    .flatMap((part) => part.split(","))
    .map((part) => Number(part.trim()))
    .filter((id) => Number.isInteger(id) && id > 0);
  return [...new Set(ids)];
};
